import React, { useContext } from 'react'
import moment from 'moment'
import { EPCRContext } from '../EPCR'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { Button, Grid, Stack } from '@mui/material'
import { isFullLayoutMode } from '../formTypes'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'

const Item = ({ label, value }) => {
  return <Grid item xs={12} md={6} lg={4} xl={3}></Grid>
}

const RecordOverview = ({ hasRequirements }) => {
  const {
    formValues,
    handleChange,
    setSelectedEPCRModule,
    isDraftDirty,
    isSaving,
    uploadState,
    downloadState,
    onExit,
  } = useContext(EPCRContext)

  if (!isFullLayoutMode(formValues?.mode) || hasRequirements) return null

  return (
    <EPCRCard>
      <Stack gap={1}>
        <DetailsBox
          noBorder
          title="Incident"
          buttonRight={
            <Button
              onClick={() => setSelectedEPCRModule('Incident')}
              color="contrast"
              variant="outlined"
              size="small"
            >
              Edit
            </Button>
          }
        >
          <DetailRow
            label="Date"
            value={moment(formValues?.incident?.incidentDate).format(
              'Do MMM YYYY HH:mm',
            )}
            noBorder
          />
        </DetailsBox>
      </Stack>
    </EPCRCard>
  )
}

export default RecordOverview
